import { BulkCreatePayrollSupplementAttendanceManualCompensationDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { i18nDateToString } from 'modules/core/lib/dates'
import { handleResult } from 'modules/core/lib/handleMutation'

interface UseBulkCreatePayrollSupplementParams {
  employeeIds: number[]
  startOn: Date
  endOn: Date
  period?: string
}

export const useBulkCreatePayrollSupplement = () => {
  const [bulkCreatePayrollSupplement, { loading, error }] = useMutation(
    BulkCreatePayrollSupplementAttendanceManualCompensationDocument,
    {
      extractorFn: (data) =>
        data.attendanceMutations.bulkCreatePayrollSupplementAttendanceManualCompensation,
    }
  )

  const bulkCompensatePeriods = async (params: UseBulkCreatePayrollSupplementParams) => {
    const { employeeIds, startOn, endOn, period } = params

    const result = await bulkCreatePayrollSupplement({
      variables: {
        employeeIds,
        startOn: i18nDateToString(startOn, 'backend'),
        endOn: i18nDateToString(endOn, 'backend'),
        period: period === 'current' ? 'current' : 'next',
      },
    })

    const handled = handleResult(result, () => undefined)

    if (handled.success) {
      return handled.data
    }

    return null
  }

  return {
    bulkCompensatePeriods,
    loading,
    error,
  }
}
